var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.33594C3 5.4506 3 4.50727 3.586 3.92194C4.17133 3.33594 5.11467 3.33594 7 3.33594H9C10.8853 3.33594 11.8287 3.33594 12.414 3.92194C13 4.50727 13 5.4506 13 7.33594V10.6693C13 12.5546 13 13.4979 12.414 14.0833C11.8287 14.6693 10.8853 14.6693 9 14.6693H7C5.11467 14.6693 4.17133 14.6693 3.586 14.0833C3 13.4979 3 12.5546 3 10.6693V7.33594Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.6693C2.46957 12.6693 1.96086 12.4586 1.58579 12.0835C1.21071 11.7084 1 11.1997 1 10.6693V6.66927C1 4.15527 1 2.89794 1.78133 2.11727C2.56267 1.3366 3.81933 1.33594 6.33333 1.33594H9C9.53043 1.33594 10.0391 1.54665 10.4142 1.92172C10.7893 2.2968 11 2.8055 11 3.33594",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.97e2126e814b535f6b6fd0dba7e4d5a5.svg";
export { ForwardRef as ReactComponent };